import React, { Fragment, useEffect, useState } from "react";
import "./dashboard.scss";
import { useNavigate } from "react-router-dom";
import { Card, Modal } from "react-bootstrap";
import moment from "moment";
import { academyusergetdetail, frontdeskdashboardcount, listevent } from "../../services/admin";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
function Frontdeskdashboard() {
    const navigate = useNavigate();
    const [role, setRole] = useState("");
    const [academy, setAcademy] = useState("");
    const [events, setEvents] = useState([]);
    const [worder, setWOrder] = useState("");
    const [vlist, setVList] = useState([]);
    const [nlist, setNList] = useState([]);
    const [elist, setEList] = useState([]);
    const [telist, setTEList] = useState([]);
    const [wcount, setWCount] = useState("");
    const [tcount, setTCount] = useState("");
    const [slist, setSList] = useState([]);
    const [tpath, setTPath] = useState("");


    const [clist, setCList] = useState([]);
    const [tclist, setTCList] = useState([]);
    const [spath, setSPath] = useState("");


    useEffect(() => {
        academyusergetdetail(localStorage.getItem("UID")).then((res) => {
            if (res.status === true) {
                setAcademy(res.data.details.academy_name);
                setRole(res.data.details.role_name);
            }
        });

        setEvents([]);
        const temp1 = new FormData();
        temp1.append("academy_id", localStorage.getItem("academy"));
        listevent(temp1).then((res) => {
            if (res.status === true) {
                setEvents(res.data.details);
            }
        });
        const temp2 = new FormData();
        temp2.append("user_id", localStorage.getItem("UID"));
        // temp2.append('date', moment(new Date()).format("YYYY-MM-DD"));
        temp2.append("date", '2025-03-07');

        frontdeskdashboardcount(temp2).then((res) => {
            if (res.status === true) {
                setTCount(res.data.teachers);
                setWCount(res.data.workercount);
                setSPath(res.data.path);
                setTPath(res.data.tpath);
                setVList(res.data.visitor);
                setCList(res.data.complaint);
                setTCList(res.data.todaycomplaint);
                setNList(res.data.notification);
                setEList(res.data.admission);
                setTEList(res.data.totaladmission);
                setWOrder(res.data.workers);
                setSList(res.data.staff);
            }
        })
    }, []);

    const startAutoScroll = () => {
        const scrollContainer = document.getElementById('auto-scroll');
        const announcementList = document.getElementById('announcement-list');

        // Duplicate the list for seamless scrolling
        if (!announcementList.classList.contains('duplicated')) {
            const clone = announcementList.cloneNode(true);
            clone.id = '';
            clone.classList.add('duplicate');
            scrollContainer.appendChild(clone);
            announcementList.classList.add('duplicated');
        }

        const scrollSpeed = 1; // Pixels per step

        if (scrollContainer) {
            window.scrollInterval = setInterval(() => {
                scrollContainer.scrollTop += scrollSpeed;

                // Reset scroll position when reaching the end of the first list
                if (scrollContainer.scrollTop >= announcementList.scrollHeight) {
                    scrollContainer.scrollTop = 0;
                }
            }, 30); // Interval in milliseconds
        }
    };

    // Start auto-scrolling on page load
    document.addEventListener('DOMContentLoaded', startAutoScroll);


    // Start auto-scrolling on page load
    document.addEventListener('DOMContentLoaded', startAutoScroll);


    const timeAgo = (date) => {
        const now = new Date();
        const dateWithOffset = new Date(new Date(date).getTime() + (5.5 * 60 * 60 * 1000));

        const diffInMs = now - dateWithOffset;
        const diffInSec = Math.floor(diffInMs / 1000);
        const diffInMin = Math.floor(diffInSec / 60);
        const diffInHour = Math.floor(diffInMin / 60);
        const diffInDay = Math.floor(diffInHour / 24);
        const diffInMonth = Math.floor(diffInDay / 30); // Approximate month
        const diffInYear = Math.floor(diffInMonth / 12);

        if (diffInSec < 60) {
            return `${diffInSec} seconds ago`;
        } else if (diffInMin < 60) {
            return `${diffInMin} minutes ago`;
        } else if (diffInHour < 24) {
            return `${diffInHour} hours ago`;
        } else if (diffInDay < 30) {
            return `${diffInDay} days ago`;
        } else if (diffInMonth < 12) {
            return `${diffInMonth} months ago`;
        } else {
            return `${diffInYear} years ago`;
        }
    };

    const [eshow, setEShow] = useState(false);
    const [eventdet, setEventDet] = useState("");
    function handleEvent(hdata) {
        setEventDet(hdata);
        setEShow(true);
    }

    function handleEventClose() {
        setEShow(false);
        setEventDet("");
    }


    const [ashow, setAShow] = useState(false);
    const [anndet, setAnnDet] = useState("");
    function handleView(hdata) {
        setAnnDet(hdata);
        setAShow(true);
    }

    function handleAClose() {
        setAShow(false);
        setAnnDet("");
    }

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState("");
    const openModal = (event) => {
        setSelectedEvent(event);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setSelectedEvent("");
        setModalIsOpen(false);
    };

    const handleEventClick = (info) => {
        const clickedEvent = {
            title: info.event.title,
            start: info.event.start,
            end: info.event.end,
            description: info.event.extendedProps.description,
            location: info.event.extendedProps.location,
            circular: info.event.extendedProps.circular === '' ? "" : info.event.extendedProps.path + info.event.extendedProps.circular,
        };
        openModal(clickedEvent);
    };
    return (
        <Fragment>
            <div className="main-container container-fluid">
                <div className="inner-body">
                    {/* Page Header */}
                    <div className="page-header">
                        <h2 className="main-content-title tx-24 mg-b-5">
                            Welcome To Dashboard
                        </h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a>Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Dashboard
                            </li>
                        </ol>
                    </div>
                    {/* End Page Header */}
                    {/*Row*/}
                    <div className="row row-sm">
                        <div className="col-sm-12 col-lg-12 col-xl-12">
                            {/*Row*/}
                            <div className="row row-sm">
                                <div className="col-sm-12 col-lg-12 col-xl-12">
                                    <div className="bg-black-2 custom-card card-box card">
                                        <div className="card-body p-4">
                                            <div className="row align-items-center">
                                                <div className="offset-xl-3 offset-sm-6 col-xl-8 col-sm-6 col-12 img-bg ">
                                                    <h4 className="d-flex  mb-3">
                                                        <span className="font-weight-bold text-white ">
                                                            {localStorage.getItem("Role") == 1
                                                                ? "AMY Technologies Public School"
                                                                : `${academy}`}
                                                        </span>
                                                    </h4>
                                                    <p className="tx-white-7 mb-1">
                                                        Welcome Back{" "}
                                                        <b className="text-warning">
                                                            {localStorage.getItem("Role") == 1
                                                                ? "Receptionist"
                                                                : `${role}`}
                                                        </b>{" "}
                                                        See our Todays Dashboard{" "}
                                                        <b className="text-warning">
                                                            {moment(new Date()).format("DD-MM-YYYY")}
                                                        </b>
                                                        <br></br>
                                                        Have a Nice Day
                                                    </p>
                                                </div>
                                                <img
                                                    src={require("../../assets/images/dashboard/front desk.png")}
                                                    alt="Student"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/*Row */}
                            {/*Row*/}
                            <div className="col-sm-12 col-lg-12 col-xl-12">
                                <div className="row row-sm">
                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                        <div class="card custom-card student-card">
                                            <div class="card-body">
                                                <div class="card-order ">
                                                    <label class="main-content-label student-name-card mb-3 pt-1">My Unique Number</label>
                                                    <h2 class="text-end card-item-icon card-icon">
                                                        <i class="fa fa-user-circle-o icon-size float-start text-primary"></i><span class="student-no font-weight-bold">{worder ? worder.username : ""}</span></h2>
                                                    {/* <p class="mb-0 text-muted">Ajithkumar<span class="float-end">XX - A</span></p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                        <div class="card custom-card student-card">
                                            <div class="card-body">
                                                <div class="card-order ">
                                                    <label class="main-content-label student-name-card mb-3 pt-1">Employee ID</label>
                                                    <h2 class="text-end card-item-icon card-icon">
                                                        <i class="fa fa-user icon-size float-start text-primary"></i><span class="student-no font-weight-bold">{worder ? worder.employee_id : ""}</span></h2>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                        <div class="card custom-card student-card">
                                            <div class="card-body">
                                                <div class="card-order ">
                                                    <label class="main-content-label student-name-card mb-3 pt-1">Today Admission Enquiry</label>
                                                    <h2 class="text-end card-item-icon card-icon">
                                                        <i class="fa fa-user-plus icon-size float-start text-primary"></i><span class="student-no font-weight-bold">{elist ? elist.length : ""}</span></h2>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                        <div class="card custom-card student-card">
                                            <div class="card-body">
                                                <div class="card-order ">
                                                    <label class="main-content-label student-name-card mb-3 pt-1">Today Visitor</label>
                                                    <h2 class="text-end card-item-icon card-icon">
                                                        <i class="fa fa-graduation-cap icon-size float-start text-primary"></i><span class="student-no font-weight-bold">{vlist ? vlist.length : ""}</span></h2>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-3">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >ENQUIRY</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{elist ? elist.length : "0"}</a>{" "}
                                                        <p className="text-muted ">Today</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{telist ? telist.length : "0"}</a>{" "}
                                                        <p className="text-muted">Total</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-3">
                                        <div className="card custom-card">
                                            <div className="card-bodyy">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >COMPLAINTS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-6 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>{tclist ? tclist.length : "0"}</a>{" "}
                                                        <p className="text-muted ">Today</p>
                                                    </h3>
                                                </div>
                                                <div className="col-md-6 col text-center float-end">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a>{clist ? clist.length : "0"}</a>{" "}
                                                        <p className="text-muted">Total</p>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xl-3">
                                        <div class="card custom-card">
                                            <div class="card-bodyy">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >TEACHERS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{tcount ? tcount.evening_present != 0 ? tcount.evening_present : tcount.morning_present : "0"}</a>{" "}
                                                        <p className="text-muted ">Present</p>
                                                    </h3>

                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{tcount ? tcount.evening_absent != 0 ? tcount.evening_absent : tcount.morning_absent : "0"}</a>{" "}
                                                        <p className="text-muted ">Absent </p>
                                                    </h3>

                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{tcount ? tcount.total_teachers : "0"}</a>{" "}
                                                        <p className="text-muted ">Total</p>
                                                    </h3>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-xl-3">
                                        <div class="card custom-card">
                                            <div class="card-bodyy">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div className="product-content">
                                                            <h3 className="title">
                                                                <a >WORKERS</a>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                                                <div className="col-md-4 col justify-content-center text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{wcount ? wcount.evening_present != 0 ? wcount.evening_present : wcount.morning_present : "0"}</a>{" "}
                                                        <p className="text-muted ">Present</p>
                                                    </h3>

                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{wcount ? wcount.evening_absent != 0 ? wcount.evening_absent : wcount.morning_absent : "0"}</a>{" "}
                                                        <p className="text-muted ">Absent </p>
                                                    </h3>

                                                </div>
                                                <div className="col-md-4 col text-center">
                                                    <h3 className="mb-1 font-weight-bold">
                                                        {" "}
                                                        <a >{wcount ? wcount.total_workers : "0"}</a>{" "}
                                                        <p className="text-muted ">Total</p>
                                                    </h3>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {/*End row*/}
                            {/*row*/}
                            <div className="row row-sm">
                                <div
                                    className="col-sm-12 col-md-12 col-lg-6 col-xl-5"
                                    data-wow-delay="1.5s"
                                >
                                    <Card className="custom-card">
                                        <Card.Header>
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="fa fa-bullhorn headericons"></i> Announcement</label>

                                            </div>
                                        </Card.Header>
                                        <Card.Body
                                            id="auto-scroll"
                                            onMouseEnter={() => clearInterval(window.scrollInterval)}
                                            // onMouseLeave={startAutoScroll}
                                            style={{
                                                maxHeight: '350px',
                                                overflow: 'hidden',
                                                position: 'relative',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <ul
                                                className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                id="announcement-list"
                                            >
                                                {nlist && nlist.length > 0 ? (
                                                    nlist.map((item, index) => (
                                                        <li key={index} className="d-flex align-items-center mb-3">
                                                            <div className="flex-shrink-0">
                                                                <div className="main-avatar avatar-md online"></div>
                                                            </div>
                                                            <div className="ms-3 flex-grow-1">
                                                                <p className="tx-16 text-dark mb-0 tx-semibold">{item.title}</p>
                                                                <p className="mb-0 text-muted tx-16">{moment(item.created_at).format('DD-MM-YYYY')}</p>
                                                            </div>
                                                            <a class="me-2 mt-1" onClick={() => handleView(item)}><span class="badge bg-success-light">View</span></a>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <h6>No Announcement found.</h6>
                                                )}
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div
                                    className="col-sm-12 col-md-12 col-lg-6 col-xl-7"
                                    data-wow-delay="1.5s"
                                >
                                    <div class="card custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="fa fa-clipboard headericons"></i> Complaints
                                                </label>

                                            </div>
                                        </Card.Header>
                                        <div class="card-body">
                                            {clist && clist.length > 0 ? (
                                                clist.map((item, index) => (
                                                    <div class="example" key={index}>
                                                        <div class="d-sm-flex comment-section">
                                                            <div class="d-flex me-3">
                                                                <a ><img
                                                                    alt="avatar"
                                                                    className="me-3 rounded-circle avatar avatar-md"
                                                                    src={item.complaint_file != '' ? spath + item.complaint_file : require("../../assets/images/user.png")}
                                                                // src={require("../../assets/images/user.png")}
                                                                /> </a>
                                                            </div>
                                                            <div class="media-body">
                                                                <h5 class="mt-0 mb-1 font-weight-semibold">{item.complaint_name}
                                                                    <a class="me-2 mt-1"><span class="tx-12 text-muted ms-2"> {timeAgo(item.created_at)}</span><span class="tx-12 badge bg-danger-light float-end">{item.priority}</span></a>
                                                                </h5>
                                                                <div className="ms-3 flex-grow-1">
                                                                    <p className="tx-16 text-dark mb-0">{item.complaint_reason}</p>
                                                                    {/* <a class="me-2 mt-1"><span class="badge bg-success-light">Reply</span></a> */}
                                                                    {/* <a class="me-2 mt-1"><span class="badge bg-danger-light">View</span></a> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                ))
                                            ) : (
                                                <h6>No Complaints found.</h6>
                                            )}
                                        </div>
                                    </div>
                                </div>



                                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="fa fa-calendar headericons"></i> Events calendar</label>

                                            </div>
                                        </Card.Header>

                                        <Card.Body>
                                            <FullCalendar
                                                plugins={[dayGridPlugin]}
                                                initialView="dayGridMonth"
                                                events={events.map(event => ({
                                                    title: event.event_name,
                                                    start: event.event_start,
                                                    end: event.event_end || event.event_start,
                                                    description: event.description,
                                                    location: event.location,
                                                    path: event.path,
                                                    circular: event.circular,
                                                    backgroundColor: '#b04751',
                                                    textColor: '#fff'
                                                }))}
                                                eventClick={handleEventClick}
                                            />
                                        </Card.Body>
                                    </Card>

                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="mdi mdi-account-check headericons"></i> Staff Attendance
                                                </label>

                                            </div>
                                        </Card.Header>

                                        <Card.Body
                                            id="birthday-scroll"
                                            onMouseEnter={() => clearInterval(window.scrollInterval)}
                                            // onMouseLeave={startBirthdayScroll}
                                            style={{
                                                maxHeight: "350px",
                                                overflow: "hidden",
                                                position: "relative",
                                            }}
                                        >
                                            <ul
                                                className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                id="birthday-list"
                                            >
                                                {slist && slist.length > 0 ? (
                                                    slist.map((item, index) => (
                                                        <li key={index} className="media d-flex mb-3 mt-0 pt-0">
                                                            <img
                                                                alt="avatar"
                                                                className="me-3 rounded-circle avatar avatar-md"
                                                                src={item.photo !== null ? tpath + item.photo : require("../../assets/images/teacher.jpg")}
                                                            />
                                                            <div className="media-body mb-1 announcement">
                                                                <div className="float-end">
                                                                    {item.attend_status == 1 ? <button className="btn btn-success btn-sm">P</button> : <button className="btn btn-danger btn-sm">A</button>}

                                                                </div>
                                                                <h5 className="media-title tx-16 mb-0">
                                                                    {item.teacher_name}
                                                                </h5>
                                                                <p className="mb-0 tx-13 text-muted">
                                                                    {`${item.class_name} - ${item.section_name}`}
                                                                </p>
                                                            </div>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <h6>No Staff Attendance found.</h6>
                                                )}

                                            </ul>
                                        </Card.Body>
                                    </Card>

                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                                    <Card className="custom-card">
                                        <Card.Header className="">
                                            <div className="d-md-flex ms-auto">
                                                <label className="main-content-label my-auto pt-2"><i className="fa fa-phone-square headericons"></i> Admission Enquiry
                                                </label>

                                            </div>
                                        </Card.Header>

                                        <Card.Body
                                            id="auto-scroll"
                                            onMouseEnter={() => clearInterval(window.scrollInterval)}
                                            // onMouseLeave={startAutoScroll}
                                            style={{
                                                maxHeight: '350px',
                                                overflow: 'hidden',
                                                position: 'relative',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <ul
                                                className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                                                id="announcement-list"
                                            >

                                                {elist && elist.length > 0 ? (
                                                    elist.map((data, index) => (
                                                        <li key={index} className="d-flex align-items-center mb-3">
                                                            <div className="flex-shrink-0">
                                                                <div className="main-avatar avatar-md online"></div>
                                                            </div>
                                                            <div className="ms-3 flex-grow-1">
                                                                <p className="tx-16 text-dark mb-0 tx-semibold">{data.student_name}</p>
                                                                <p className="mb-0 text-muted">{data.phone}</p>
                                                            </div>
                                                            <a class="me-2 mt-1" onClick={() => handleEvent(data)}><span class="badge bg-success-light">View</span></a>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <h6>No Admission Enquiry found.</h6>
                                                )}


                                            </ul>
                                        </Card.Body>
                                    </Card>

                                </div>
                                {/* col end */}
                            </div>
                            {/* Row end */}
                        </div>

                        <Modal show={eshow} onHide={handleEventClose}>
                            <Modal.Header>
                                <Modal.Title>Admission Enquiry</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Student</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a>{eventdet.student_name}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Father Name</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a>{eventdet.father_name}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Phone Number</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a>{eventdet.phone}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label>Address</label>
                                                </div>
                                                <div className="col-md-6">
                                                    <a>{eventdet.address}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <a className="btn btn-secondary" onClick={handleEventClose}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={ashow} onHide={handleAClose}>
                            <Modal.Header>
                                <Modal.Title>Announcement Details</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>Title</label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{anndet.title}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label>
                                                        Message
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <a>{anndet.message}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </Modal.Body>

                            <Modal.Footer>
                                <a className="btn btn-secondary" onClick={handleAClose}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>


                        <Modal show={modalIsOpen} size="md">
                            <Modal.Header>
                                <Modal.Title>Events</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="table-responsive">
                                    <h4>{selectedEvent.title}</h4>
                                    <p><strong>Start Date :</strong> {moment(selectedEvent.start).format('DD-MM-YYYY')}</p>

                                    <p><strong>End Date :</strong> {selectedEvent.end ? moment(selectedEvent.end).format('DD-MM-YYYY') : moment(selectedEvent.start).format('DD-MM-YYYY')}</p>

                                    <p><strong>Location :</strong> {selectedEvent.location}</p>
                                    <p><strong>Description :</strong> {selectedEvent.description}</p>
                                    {selectedEvent.circular !== "" && <p><strong>Circular:</strong> <a href={selectedEvent.circular} target="_blank" rel="noopener noreferrer">View Circular</a></p>}

                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <a className="btn btn-info" onClick={closeModal}>
                                    Close
                                </a>
                            </Modal.Footer>
                        </Modal>


                    </div>
                    {/* Row end */}
                </div>
            </div>
        </Fragment>
    );
}


export default Frontdeskdashboard;
